// @flow
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import { openSettingsModal, closeSettingsModal, NONE, PRIMARY, SECONDARY } from './actions';
import handleReduce from '~/core/state/handle-reduce';

const initialState = fromJS({
    modal: NONE,
    type: null,
    id: null,
    setting: null
});

const actionHandlers = new Map([
    [
        openSettingsModal,
        handleReduce((state, { payload }) => {
            if (payload.modal === PRIMARY) {
                // $FlowFixMe
                return state.withMutations(state =>
                    state
                        .set('modal', PRIMARY)
                        .set('type', payload.type)
                        .set('id', payload.id)
                        .set('props', payload.props)
                );
            }
            if (payload.modal === SECONDARY) {
                // $FlowFixMe
                return state.withMutations(state => state.set('modal', SECONDARY).set('setting', payload.setting));
            }
            return initialState;
        })
    ],
    [
        closeSettingsModal,
        handleReduce((state, { payload }) => {
            if (payload.modal === PRIMARY) {
                // $FlowFixMe
                return state.withMutations(state =>
                    state
                        .set('modal', NONE)
                        .set('type', null)
                        .set('id', null)
                        .set('setting', null)
                );
            }
            if (payload.modal === SECONDARY) {
                // $FlowFixMe
                return state.set('modal', PRIMARY);
            }
            return initialState;
        })
    ]
]);

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/settings-modal/index.js